import React, { useContext, useEffect, useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import RegisterLayout from "./RegisterLayout";
import InputFieldV2 from "../../../lib/input/InputFieldV2";
import PhoneInputV2 from "../../../lib/input/Phoneinputv2";
import { crewReferenceFormData } from "../../../data/formData";
import { apiConstants } from "../../../utils/apiConstants";
import {
    EMAIL_VALIDATION,
    MOBILE_VALIDATION,
    REQUIRED_VALIDATION,
} from "../../../lib/input/validation-rules";
import { errorMessage, placeholder } from "../../../utils/constants";
import { MyContext } from "../../../context";
import { emptyFunction, showToast, validatePhoneNumber } from "../../../utils";
import { makeDeleteCall, makeGetCall } from "../../../effects/requests";
import { endPoints } from "../../../utils/endpoints";
import References from "./References";

interface ReferenceType {
    reference_name: string;
    reference_email: string;
    reference_mobile_number: string;
    dial_code: string;
}

interface AddReferenceProps {
    onNext: (data: ReferenceType[]) => void;
    onPrevious: () => void;
}

const AddReference: React.FC<AddReferenceProps> = ({
    onNext,
    onPrevious,
}) => {

    const { userData } = useContext(MyContext);

    const methods = useForm({
        mode: "all",
        defaultValues: {
            ...crewReferenceFormData(),
        },
        reValidateMode: "onBlur",
    });

    const [references, setReferences] = useState<any>([]);

    const userEmail = userData?.email;

    const addReference: SubmitHandler<any> = (data) => {
        const payload = {
            ...data,
        };

        const duplicateReference = references.find((item: any) => item.reference_email?.toLowerCase() === payload?.reference_email?.toLowerCase());

        if (duplicateReference) {
            alert("Reference email already added");
            return;
        }

        if (payload.reference_email?.toLowerCase() === userEmail?.toLowerCase()) {
            alert("You cannot add yourself as a reference");
            return;
        }

        if (!validatePhoneNumber(`${payload?.dial_code?.dial_code}${payload?.[apiConstants.reference_mobile_number]}`)) {
            showToast(errorMessage.invalid_mobile_msg, 'error', 'mobile')
            return
        }

        const filteredPayload = { ...payload };
        delete filteredPayload.dial_code

        setReferences((prev: any) => [...prev, filteredPayload]);

        methods.reset({ ...crewReferenceFormData() });
    };

    const handleNext = () => {
        // if (!references.length) {
        //     showToast("Please add at least one reference", 'error');
        //     return;
        // }

        onNext(references);
    };

    const removeReference = (item: any, index: any) => {
        const allData = [...references];
        if (item?.id) {
            const url = `${endPoints.REFERENCE_URL}${item?.id}`
            makeDeleteCall(url).then((res: any) => {
                allData.splice(index, 1);
                setReferences(allData)
            }).catch(emptyFunction)
        } else {
            allData.splice(index, 1);
            setReferences(allData)
        }
    }

    const fetchUserRef = () => {
        makeGetCall(endPoints.REFERENCE_URL).then((res: any) => {
            if (res?.status?.code == 200) {
                const allData = res?.results?.length as never > 0 ? res?.results : res?.data?.length > 0 ? res?.data : [];
                setReferences(allData)
            }
        }).catch(emptyFunction)
    }

    useEffect(() => {
        fetchUserRef()
    }, [])

    return (
        <RegisterLayout showLogout hideHeader>
            <FormProvider {...methods}>
                <div className="register-step">

                    {/* Heading */}
                    <div className="register-step__heading-block">
                        <h1 className="register-step__title">
                            Add References
                        </h1>

                        <p className="register-step__description">
                            Add references to strengthen your profile and
                            credibility.
                        </p>
                    </div>

                    {/* Form */}
                    <div className="personal-info__form">

                        <References
                            onDelete={(item: any, index: any) => removeReference(item, index)}
                            data={references}
                        />

                        <div className="personal-info__row">
                            <div className="personal-info__field">
                                <label className="personal-info__label">
                                    Full name
                                </label>

                                <InputFieldV2
                                    name={apiConstants.reference_name}
                                    type="text"
                                    placeholder="Enter your full name"
                                    rules={REQUIRED_VALIDATION("Full name")}
                                />
                            </div>

                            <div className="personal-info__field">
                                <label className="personal-info__label">
                                    Email
                                </label>

                                <InputFieldV2
                                    name={apiConstants.reference_email}
                                    type="email"
                                    placeholder={placeholder.email}
                                    rules={EMAIL_VALIDATION}
                                />
                            </div>
                        </div>

                        <PhoneInputV2
                            name={apiConstants.reference_mobile_number}
                            countryName={apiConstants.dial_code}
                            label="Phone number"
                            placeholder={placeholder.contactNumber}
                            rules={MOBILE_VALIDATION}
                        />
                    </div>

                    {/* Add Another */}
                    <div className="add-jobs__add-row">
                        <button
                            type="button"
                            className="btn-add-another"
                            onClick={methods.handleSubmit(addReference)}
                        >
                            + Add another
                        </button>
                    </div>

                    {/* Footer */}
                    <div className="register-step__footer">
                        <button
                            type="button"
                            className="btn-next btn-next--yellow"
                            style={{ marginRight: 15 }}
                            onClick={onPrevious}
                        >
                            Previous
                        </button>

                        <button
                            type="button"
                            className="btn-next btn-next--yellow"
                            onClick={handleNext}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </FormProvider>
        </RegisterLayout>
    );
};

export default AddReference;